{
  "links" : {
    "triggerLinksDescription" : "Enlaces de activación Habilitar tú para poner enlaces en el interior de mensajes SMS y Gmail, que habilitar tú para rastrear actividades específicas de los clientes y Activador sucesos/incidentes/repeticiones en función de Activado cuando se hace clic en el enlace.",
    "enterName" : "Introduce el nombre",
    "enterLinkURL" : "Introduce URL del enlace",
    "save" : "Archivar",
    "cancel" : "Cancelar",
    "delete" : "Borrar",
    "aboutToDeleteLink" : "`Tú estás Acerca de para eliminar el ${deleteRowName} Activador Enlace. Eliminado El enlace no se puede restablecer. ¿Estás seguro de que quieres continuar?`",
    "noTriggerLinksFound" : "No hay enlaces de activación encontrados",
    "getStartedByAddingNewTriggerLinks" : "Empezar Vía añadiendo Nuevos Enlaces de activación",
    "newTriggerLink" : "Nuevo activador Enlace",
    "searchNoMatch" : "Tu Buscar no coincide con ningún Activador Enlace.",
    "link" : "Enlace",
    "addLink" : "Añadir Enlace",
    "linkURL" : "URL del enlace",
    "name" : "Nombre",
    "pleaseEnterNonEmptyLinkName" : "Por favor, introduce un nombre de Enlace que no esté vacío",
    "pleaseEnterURL" : "Introduce la URL",
    "actions" : "Actividades",
    "linkKey" : "Clave del Enlace",
    "keyCopied" : "Clave Copiado"
  }
}
